<template>
    <div class="wrap">
        <listHeader
            :title="postData.tid > 0 ? '编辑老师' : '新增老师'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="类型"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    v-decorator="['type', {required: true, rules: [{ message: '选择老师类型' }], initialValue: ''}]">>
                                    <a-select-option value="">选择老师类型</a-select-option>
                                    <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="老师名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入老师名称" v-decorator="['tname', {rules: [{ required: true, max: 32, message: '请输入老师名称' }], initialValue: ''}]"/>
                            </a-form-item>


                            <a-form-item
                                label="手机号"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写手机号"
                                         v-decorator="['mobile', {rules: [{ required: true, validator: requiredMobile,  message: '请填写正确的手机号' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="身份证"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请填写身份证"
                                         v-decorator="['idcard', {rules: [{ required: false, validator: checkIdcard,  message: '请填写正确的身份证号码' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="老师介绍"
                                v-bind="formItemLayout"
                            >
                                <a-textarea
                                    v-decorator="['remark',{rules: [{ required: false, max: 128, message: '请填写老师介绍' }]} ]"
                                    placeholder="请填写老师介绍"
                                    :auto-size="{ minRows: 2 }"
                                />
                            </a-form-item>

                            <a-form-item
                                label="头像"
                                v-bind="formItemLayout"
                            >
                                <a-upload
                                    name="avatar"
                                    list-type="picture-card"
                                    class="avatar-uploader"
                                    :show-upload-list="false"
                                    :customRequest="uploadImg"
                                >
                                    <div v-if="image">
                                        <img :src="image" alt="avatar"/>
                                    </div>
                                    <div v-else-if="image_str">
                                        <img :src="image_str" alt="avatar"/>
                                    </div>
                                    <div v-else>
                                        <a-icon :type="loading ? 'loading' : 'plus'"/>
                                        <div class="ant-upload-text">
                                            选择图片
                                        </div>
                                    </div>
                                </a-upload>
                                <p v-if="image" style="display: block; padding:0;font-size:14px;color:#1483cc">
                                    <a @click="reUpload">重新上传</a>
                                    <a @click="turnImg" style="padding-left:10px;">旋转照片</a>
                                </p>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import Common from '@/assets/js/common';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'teacherCreate',
            visible: false, // 是否显示图片src
            loading: false, // 显示上传中
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'tid': '',
            },
            data: {},
            config: {},
            turn: {
                image: '',
                turns: 0
            },
            image: '',
            image_str: '',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/teacher/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.tid) {
                    if (res.data.avatar) {
                        this.image_str = res.data.avatar_str;
                    }

                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            type: res.data.type,
                            tname: res.data.tname,
                            mobile: res.data.mobile,
                            idcard: res.data.idcard,
                            remark: res.data.remark,
                            ordernum: res.data.ordernum,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.tid > 0) {
                            url = '/manage/teacher/edit';
                            values.tid = this.postData.tid;
                        } else {
                            url = '/manage/teacher/save';
                        }

                        if (this.image) {
                            values.image = this.image;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
        reUpload() {
            this.image = '';
        },
        turnImg() {
            // 初始化
            if (this.turn.image == '') {
                this.turn.image = new Image();
                this.turn.image.src = this.image;
            }
            this.image = Common.turnImg(this.turn);
        },
        uploadImg(e, maxsize=40, zoom=0.8, width=400, height=400) {
            this.visible = false;
            this.loading = true;

            let that = this;
            let zo = zoom;
            let reader = new FileReader();
            reader.readAsDataURL(e.file);

            reader.onload = function () {
                let size = this.result.length / 1024;
                let avatar = this.result;

                if (maxsize != 0 && size > maxsize) {

                    let image = new Image()
                    image.src = avatar;

                    new Promise(()=>{
                        image.onload = () => {
                            do {
                                avatar = Common.compressImg(image, zo, width, height);
                                zo -= 0.1;
                            } while (avatar.length / 1024 > maxsize && zo > 0.1)

                            that.image = avatar;
                        };
                    });
                } else {
                    that.image = avatar;
                }

                this.loading = false;
            };
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
